/**
 * Marketing uses facebook to track facebook ads.
 */

import React, { Fragment } from 'react';
import { loadScript } from './loadScript.js';

export const facebookId = '1173492152832305';
export const facebookIdForLogin = '154338725051675';
export const loadFBScript = () => {
  return loadScript({ id: 'facebookScript', src: 'https://connect.facebook.net/en_US/sdk.js' });
};

export const FacebookPixel = () => {
  let imgsrc = `https://www.facebook.com/tr?id=${facebookId}&ev=PageView&noscript=1`;
  return (
    <Fragment>
      <script
        dangerouslySetInnerHTML={{
          __html: `
    !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    fbq('dataProcessingOptions', ['LDU'], 0, 0);
    fbq('init', '${facebookId}');
    fbq('track', 'PageView');
    `,
        }}></script>
      <noscript>
        <img height='1' width='1' src={imgsrc} />
      </noscript>
    </Fragment>
  );
};

//enter-location custome event
//web-sign-up custome event
//add-to-cart
//checkout-page-view
//first-purchase
//purchase

class FBEvents {
  enterLocation() {
    // eslint-disable-next-line no-undef
    fbq && fbq('trackCustom', 'enter-location');
  }
  trackEnterLocation() {
    //eslint-disable-next-line no-undef
    fbq && fbq('trackCustom', 'enter-location');
  }

  trackWebSignUp(provider) {
    // eslint-disable-next-line no-undef
    fbq &&
      fbq('trackCustom', 'web-sign-up', {
        provider: provider,
      });
  }

  trackAddToCart() {
    // eslint-disable-next-line no-undef
    fbq && fbq('trackCustom', 'add-to-cart');
  }

  trackCheckoutPageView() {
    // eslint-disable-next-line no-undef
    fbq && fbq('trackCustom', 'checkout-page-view');
  }

  trackFirstTimePurchase({ total, currency = 'USD' }) {
    // eslint-disable-next-line no-undef
    fbq &&
      fbq('trackCustom', 'first-purchase', {
        value: total,
        currency,
      });
  }

  trackPurchase({ total, currency = 'USD' }) {
    // eslint-disable-next-line no-undef
    fbq('trackCustom', 'purchase', {
      value: total,
      currency,
    });
  }
}

export const fbEvents = new FBEvents();
